import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCarousel, MatCarouselComponent } from 'ng-mat-carousel';

@Component({
  selector: 'app-images-and-videos',
  templateUrl: './images-and-videos.component.html',
  styleUrls: ['./images-and-videos.component.css']
})
export class ImagesAndVideosComponent implements OnInit {
  currentIndex = 0;
  slides = [];
  interval = 2000;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef:MatDialogRef<ImagesAndVideosComponent>) {
    console.log(data)
    this.slides = data.images.attachments;
  }

  ngOnInit(): void {
  }

  setVideoDuration(index: number, event: Event): void {
    const videoElement = event.target as HTMLVideoElement;
    if (videoElement && videoElement.duration) {
      const durationMs = videoElement.duration * 1000; 
      this.slides[index].duration = durationMs;
    } 
  }

  onVideoPlay(index: number): void {
    const slide = this.slides[index];
    if (slide.mimeType.startsWith('video') && slide.duration) {
      this.interval = slide.duration;
    }
    else{
      this.interval = 2000;
    }
  }

  onVideoPause(index: number): void {
    this.interval = 2000;
  }

}
